import React, { useState } from 'react'
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";
import { Button, TextField, FormControl, FormGroup, FormControlLabel, Checkbox, FormLabel } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  formClass: {
    display: "flex",
    //width: "100vw",
    //justifyContent: "space-between",
    flexWrap: "wrap",
    flexDirection: "column",
    //alignItems: "center",
    padding: "10px",
  }
});

const SearchFilter = (props) => {
  const classes = useStyles();

  /*
  const [description, setDescription] = useState("");
  const [severity, setSeverity] = useState({
    Minor: false,
    Major: false,
    Critical: false
  });
  const [status, setStatus] = useState({
    Open: false,
    InProgress: false,
    Closed: false
  });
  */

  const [description, setDescription] = useState(props.description);
  const [severity, setSeverity] = useState(props.severity);
  const [status, setStatus] = useState(props.status);

  const handleStatusChange = (event) => {
    setStatus({...status, [event.target.name]: event.target.checked});
    props.setStatus({...status, [event.target.name]: event.target.checked});
  }

  const handleSeverityChange = (event) => {
    setSeverity({...severity, [event.target.name]: event.target.checked});
    props.setSeverity({...severity, [event.target.name]: event.target.checked});
  }

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
    props.setDescription(event.target.value);
  }

  const setInitialState = () => {
    setDescription("");
    props.setDescription("");
    setSeverity({
      Minor: false,
      Major: false,
      Critical: false
    });
    props.setSeverity({
      Minor: false,
      Major: false,
      Critical: false
    });
    setStatus({
      Open: false,
      InProgress: false,
      Closed: false
    });
    props.setStatus({
      Open: false,
      InProgress: false,
      Closed: false
    });
  }

  const onSubmit = (event) => {
    event.preventDefault();
    let searchString = "&";
    Object.entries(severity).forEach(([key, value]) => {
      if (value) {
        searchString = searchString + `severity=${key}&`;
      }
    })
    Object.entries(status).forEach(([key, value]) => {
      if (value) {
        searchString = searchString + `status=${key === "InProgress" ? "In Progress" : key}&`;
      }
    })
    description.length > 0 ? searchString = searchString + `description_like=${description}` : searchString = searchString.slice(0,-1);
    //console.log(searchString);
    //console.log(props);
    props.toggleDrawer(false);
    props.actions.initIssues(searchString);
  }

  const severityCheckBox = Object.entries(severity).map(([key, value]) => {
    //console.log(key, value)
    return (
      <FormControlLabel
        key={key}
        control={
          <Checkbox
            color="primary"
            checked={value} 
            onChange={handleSeverityChange} 
            name={key} />}
        label={key}
      />
    )
  })

  const statusCheckBox = Object.entries(status).map(([key, value]) => {
    //console.log(key, value)
    return (
      <FormControlLabel
        key={key}
        control={
          <Checkbox
            color="primary"
            checked={value} 
            onChange={handleStatusChange} 
            name={key} />}
        label={key}
      />
    )
  })

  return (
    <>
      <h2 style={{paddingLeft: "10px"}}>Apply Filters</h2>
      <form className={classes.formClass} onSubmit={onSubmit}>
        <TextField
          id="description"
          name="description"
          label="Description"
          value={description}
          onChange={handleDescriptionChange}
        />
        <br></br>
        <br></br>
        <FormControl component="fieldset">
          <FormLabel component="legend">Severity</FormLabel>
          <FormGroup className="col">
            {severityCheckBox}
          </FormGroup>
        </FormControl>
        <br></br>
        <br></br>
        <FormControl component="fieldset">
          <FormLabel component="legend">Status</FormLabel>
          <FormGroup>
            {statusCheckBox}
          </FormGroup>
        </FormControl>
        <br></br>
        <br></br>
        <div>
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Apply
          </Button>
          &nbsp;&nbsp;
          <Button
            color="secondary"
            variant="contained"
            onClick={() => {
              setInitialState();
              props.toggleDrawer(false);
              props.actions.initIssues("");
            }}
          >
            Clear
          </Button>
        </div>
      </form>
    </>
  )
}

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchFilter));
